import * as React from "react";
import { useLocation } from "@grandvisionhq/frk-routing";
import { ProductCatalogBreadcrumbs } from "@grandvisionhq/products";
import { useIntl } from "@grandvisionhq/state";
import { createProductTypeBreadcrumb, getProductTypeName, capitalizeWords } from "./utils.js";
import { useBrPageContext } from "../../../../../../context/context/context.js";
import { useBloomreachProductRoutes } from "../../../../../../hooks/hooks/use-bloomreach-product-routes.js";
import { useBloomreachPageRoutes } from "../../../../../../hooks/hooks/use-bloomreach-page-routes.js";
const CmsProductCatalogBreadcrumbs = ({ title }) => {
  const [, pageRoutes] = useBloomreachProductRoutes();
  const { routes } = useBloomreachPageRoutes();
  const { pathname } = useLocation();
  const page = useBrPageContext();
  const { getLabel } = useIntl();
  const createUrl = (url) => url && page?.isPreview() ? page.getUrl(url) : url;
  const sanitizedPath = pathname?.split("?")[0];
  const rootBreadcrumb = {
    name: getLabel("account.menu.home", { defaultValue: "Home" }),
    url: createUrl(routes.root)
  };
  const breadcrumbs = [rootBreadcrumb];
  const productTypeBreadcrumb = createProductTypeBreadcrumb(pageRoutes, sanitizedPath, createUrl);
  if (productTypeBreadcrumb.name) {
    productTypeBreadcrumb.name = getProductTypeName(productTypeBreadcrumb, getLabel, page);
    breadcrumbs.push(productTypeBreadcrumb);
  }
  if (productTypeBreadcrumb.url !== sanitizedPath) {
    const sanitizedPathParts = sanitizedPath.split("/").filter(Boolean);
    if (productTypeBreadcrumb.url === void 0) {
      breadcrumbs.push({ name: title });
    } else {
      sanitizedPathParts.forEach((pathPart, index) => {
        if (index > 0) {
          const subBrandUrl = `${breadcrumbs[breadcrumbs.length - 1].url}/${pathPart}`;
          breadcrumbs.push({
            name: capitalizeWords(pathPart),
            url: createUrl(subBrandUrl)
          });
        }
      });
    }
  }
  return /* @__PURE__ */ React.createElement(ProductCatalogBreadcrumbs, { breadcrumbs });
};
export {
  CmsProductCatalogBreadcrumbs,
  CmsProductCatalogBreadcrumbs as default
};
//# sourceMappingURL=ProductCatalogBreadcrumbs.js.map
